 <template>
  <div class="container-fluid mt-4" dir="rtl">
    
    <!-- 1. لوحة التحكم والفلاتر -->
    <div class="card shadow-sm mb-4 border-top-primary no-print">
      <div class="card-header bg-white py-3">
        <h5 class="mb-0 text-primary fw-bold">
          <i class="fas fa-language ms-2"></i> طباعة كشوف تسليم أوراق اللغات (ورقي)
        </h5>
      </div>
      <div class="card-body">
        <div class="row g-3 align-items-end">
          
          <div class="col-md-4">
            <label class="form-label fw-bold">الفصل الدراسي</label>
            <select v-model="form.term" @change="getSubjects(form.term)" class="form-select">
              <option value="">-- اختر الفصل --</option>
              <option v-for="t in terms" :key="t.id" :value="t">{{ t.name }}</option>
            </select>
          </div>

          <div class="col-md-4">
            <label class="form-label fw-bold">المادة</label>
            <select v-model="form.subject" class="form-select" :disabled="!form.term">
              <option value="">-- اختر المادة --</option>
              <option v-for="s in subjects" :key="s.id" :value="s">{{ s.name }}</option>
            </select>
          </div>

          <div class="col-md-4 text-end">
            <button @click="fetchStudents" class="btn btn-primary px-4 fw-bold" :disabled="loading || !form.subject">
              <span v-if="loading" class="spinner-border spinner-border-sm ms-1"></span>
              <span v-else><i class="fas fa-search ms-1"></i> عرض الكشف</span>
            </button>
            
            <button @click="printPage" class="btn btn-dark px-4 fw-bold ms-2" :disabled="students.length === 0">
              <i class="fas fa-print ms-1"></i> طباعة
            </button>
          </div>

        </div>
      </div>
    </div>

    <!-- 2. منطقة التقرير (للطباعة) -->
    <div v-if="students.length > 0" class="print-area" id="printMe">
      
      <table class="table table-bordered border-dark text-center align-middle custom-table mb-0">
        <thead>
          <!-- الترويسة الرسمية -->
          <tr class="header-row border-0">
            <td colspan="5" class="border-0 p-0">
              <div class="header-content pb-3 pt-2">
                <div class="row align-items-center text-center">
                  <div class="col-4 text-start pe-4">
                      <h6 class="fw-bold m-0">محافظة شمال سيناء</h6>
                      <h6 class="fw-bold m-0">مديرية التربية والتعليم</h6>
                      <h6 class="fw-bold m-0">لجنة النظام والمراقبة</h6>
                  </div>
                  <div class="col-4">
                      <h3 class="fw-bold text-decoration-underline mb-2">كشف استلام أوراق إجابة</h3>
                      <!-- التغيير هنا -->
                      <div class="border border-2 border-dark px-4 py-1 d-inline-block fw-bold bg-light rounded-pill">
                          مدارس اللغات
                      </div>
                  </div>
                  <div class="col-4 text-center ps-4">
                      <h6 class="fw-bold m-0">الشهادة الإعدادية {{ currentYear }}</h6>
                      <h6 class="fw-bold m-0 mt-1">{{ form.term ? form.term.name : '' }}</h6>
                  </div>
                </div>

                <div class="info-bar border-top border-bottom border-2 border-dark mt-3 py-2 bg-white d-flex justify-content-between px-3 align-items-center">
                    <div class="fs-5 fw-bold">
                        المادة: <span class="text-decoration-underline">{{ form.subject.name }}</span>
                    </div>
                    <div class="fs-5 fw-bold">
                        عدد الأوراق: ( {{ students.length }} )
                    </div>
                    <div class="fs-6 fw-bold">
                        التاريخ: ........................
                    </div>
                </div>
              </div>
            </td>
          </tr>
   <tr class="bg-light">
            <th width="5%">م</th>
            <th width="15%">رقم المجموعة</th>
            <th width="15%">الرقم السري</th> <!-- هام للكنترول -->
          
            <th width="30%">توقيع الاستلام / ملاحظات</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(student, index) in students" :key="index">
            <td class="fw-bold">{{ index + 1 }}</td>
            <td class="fw-bold fs-5">{{ student.group_no }}</td>
            <!-- عرض الرقم السري بخط واضح -->
            <td class="fw-bold fs-5 font-monospace">{{ student.Secret_No || '---' }}</td>
          
            <!-- خانة فارغة للتوقيع اليدوي -->
            <td class="signature-cell"></td>
          </tr>
        </tbody>
      </table>

      <!-- التذييل -->
      <div class="footer-section mt-4 px-5 page-break-inside-avoid">
        <div class="row text-center fw-bold">
          <div class="col-4">
            <p class="mb-4">المستلم (عضو الكنترول)</p>
            <p>.............................</p>
          </div>
          <div class="col-4">
            <p class="mb-4">المسلم (رئيس اللجنة)</p>
            <p>.............................</p>
          </div>
          <div class="col-4">
            <p class="mb-4">رئيس الكنترول</p>
            <p>.............................</p>
          </div>
        </div>
      </div>

    </div>
    
    <div v-else-if="searched && !loading" class="text-center py-5 no-print text-muted border rounded bg-light mt-3">
        <i class="fas fa-file-excel fa-3x mb-3 opacity-50"></i>
        <h5>لا يوجد طلاب لغات مسجلين لهذه المادة</h5>
    </div>

  </div>
</template>

<script>
import api from '@/api/axios';

export default {
  name: "LanguagePaperPrint",
  data() {
    return {
      currentYear: new Date().getFullYear(),
      loading: false,
      searched: false,
      terms: [], subjects: [], students: [],
      form: { term: "", subject: "" }
    };
  },
  mounted() {
    this.fetchTerms();
  },
  methods: {
    async fetchTerms() {
      try {
        const res = await api.get('/getterms'); 
        this.terms = res.data;
      } catch (e) { console.error(e); }
    },
    async getSubjects(term) {
      this.form.subject = "";
      if (!term) return;
      try {
        const res = await api.get(`/getSubject/${term.id}`);
        this.subjects = res.data;
      } catch (e) { console.error(e); }
    },
    async fetchStudents() {
      if (!this.form.subject) return;
      this.loading = true;
      this.searched = true;
      this.students = [];
      try {
        // التغيير هنا: استدعاء رابط اللغات
        const res = await api.post('/admin/students/language-list', {
            subject_id: this.form.subject.id,
            term_id: this.form.term.id
        });
        this.students = res.data;
      } catch (e) { alert("حدث خطأ"); } 
      finally { this.loading = false; }
    },
    printPage() {
      this.$htmlToPaper("printMe");
    }
  }
};
</script>

<style scoped>
.border-top-primary { border-top: 4px solid #0d6efd; }
.signature-cell { height: 50px; }
.font-monospace { font-family: 'Courier New', Courier, monospace; }

@media print {
    @page { size: A4 portrait; margin: 10mm; }
    body * { visibility: hidden; }
    .no-print { display: none !important; }
    .print-area, .print-area * { visibility: visible; }
    .print-area { position: absolute; left: 0; top: 0; width: 100%; }
    thead { display: table-header-group; }
    tfoot { display: table-footer-group; }
    tr { page-break-inside: avoid; }
    .table { width: 100%; border-collapse: collapse; }
    .custom-table th, .custom-table td { border: 1px solid #000 !important; font-size: 13pt !important; padding: 8px !important; }
    .header-row td { border: none !important; }
    .bg-light { background-color: #f0f0f0 !important; -webkit-print-color-adjust: exact; }
    .page-break-inside-avoid { page-break-inside: avoid; }
}
</style>